// extracted by mini-css-extract-plugin
export var layoutContainer = "_74-0";
export var layoutContainerNoRounding = "_74-6";
export var layoutContainerOpen = "_74-5";
export var layoutContainerResizing = "_74-1";
export var mainContent = "_74-2";
export var resizeDivider = "_74-3";
export var slidePanel = "_74-4";